export const GRAPHQL_URL = "https://relink3.herokuapp.com/v1/graphql";
